import React, { Component } from 'react';

import ModalActionCreator from 'action_creators/modal';
import PricingModal from '../pricing_modal/PricingModal';

import DATA from '../data';
import '../index.scss';

class Certificates extends Component {
  openPricingModal = (tour) => {
    const modalSettings = {
      content: (
        <PricingModal
          tour={tour}
          submitPricingSelection={this.submitPricingSelection}
        />
      ),
    };

    ModalActionCreator.show(modalSettings);
  };

  submitPricingSelection = (selectionData) => {
    this.props.submitPricingSelection(selectionData);
    this.props.history.push(
      `/${this.props.match.params.guide_slug}/gift_certificates/checkout`
    );
  };

  render() {
    const certificates = DATA.tours.map((tour) => (
      <div className="certificate" key={tour.id}>
        <div className="name">{tour.name}</div>
        <div className="content">
          <div
            className="image"
            style={{ backgroundImage: `url('${tour.image}')` }}
          />
          <div className="details">
            <div className="description">
              {tour.description.split('\n').map((text) => {
                return <p>{text}</p>;
              })}
            </div>
            <div className="actions">
              <div className="price">
                from <span>{tour.pricing.base_price}</span>
              </div>
              <div
                className="buyButton ui fluid huge button anygreen"
                onClick={() => this.openPricingModal(tour)}
              >
                Buy Now
              </div>
            </div>
          </div>
        </div>
      </div>
    ));

    return (
      <div className="giftCertificates">
        <div className="certificates">
          <div className="heading">Gift Certificates</div>
          {certificates}
        </div>
      </div>
    );
  }
}

export default Certificates;
